export default __webpack_public_path__ + "static/media/Background.e33aa5db.svg";